











import { Component, Prop, Vue } from "vue-property-decorator";
import InfoPopover from "../../components/InfoPopover.vue";

/** 与 FormAbSmartVerdict 对齐 */
const VERDICT = {
  COLLECTING: 0,
  NO_WINNER_YET: 1,
  SUGGEST_WINNER: 2,
  DATA_ANOMALY: 3,
} as const;

@Component({
  components: { InfoPopover, 'info-popover': InfoPopover },
})
export default class SmartAbVerdictBanner extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean;
  @Prop({ type: Number, default: null }) verdict!: number | null;
  @Prop({ type: Object, default: null }) detail!: {
    verdict?: number;
    suggestedWinFormId?: string;
    winProbabilityChallenger?: number;
    baselineExposure?: number;
    challengerExposure?: number;
  } | null;
  @Prop({ type: Array, default: () => [] }) abFormList!: Array<{ formId?: string; name?: string }>;
  /** Nacos grayscale.formAbSmartMinExposure，默认 1000 */
  @Prop({ type: Number, default: 1000 }) minExposure!: number;

  get toneClass() {
    if (this.verdict === VERDICT.SUGGEST_WINNER) return "is-suggest";
    if (this.verdict === VERDICT.DATA_ANOMALY) return "is-anomaly";
    if (this.verdict === VERDICT.NO_WINNER_YET) return "is-waiting";
    return "is-collect";
  }

  get exposureThreshold() {
    const n = Number(this.minExposure);
    return !n || n < 1 ? 1000 : n;
  }

  get exposureThresholdLabel() {
    return String(this.exposureThreshold).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  /** 建议优胜用 A/B 字母（对齐 Figma） */
  get suggestedLetter() {
    const id = this.detail?.suggestedWinFormId;
    if (!id) return "";
    const idx = (this.abFormList || []).findIndex((f) => f.formId === id);
    if (idx === 0) return "A";
    if (idx === 1) return "B";
    return "";
  }

  get suggestedName() {
    return this.suggestedLetter || this.detail?.suggestedWinFormId || "-";
  }

  get winProbPct() {
    const p = this.detail?.winProbabilityChallenger;
    if (p == null || Number.isNaN(p)) return null;
    const lead = Math.max(p, 1 - p);
    return (lead * 100).toFixed(1);
  }

  get titleText() {
    if (this.verdict === VERDICT.SUGGEST_WINNER) {
      return this.$tx("form.smartAb.verdict.suggest", "建议优胜版本：{name}").replace(
        "{name}",
        this.suggestedName || "-",
      );
    }
    if (this.verdict === VERDICT.NO_WINNER_YET) {
      return this.$tx("form.smartAb.verdict.noWinner", "暂未产生胜者");
    }
    if (this.verdict === VERDICT.DATA_ANOMALY) {
      return this.$tx("form.smartAb.verdict.anomaly", "数据异常");
    }
    return this.$tx("form.smartAb.verdict.collecting", "继续收集");
  }

  get descText() {
    const n = this.exposureThresholdLabel;
    if (this.verdict === VERDICT.SUGGEST_WINNER) {
      return this.$tx(
        "form.smartAb.verdict.suggestDesc",
        "两个版本均已达到{n}名独立曝光访客，{name} 版本胜出概率 {p}%（≥90%）。人工确认前不会自动改变线上弹窗。",
      )
        .replace("{n}", n)
        .replace("{name}", this.suggestedName || "-")
        .replace("{p}", this.winProbPct || "-");
    }
    if (this.verdict === VERDICT.NO_WINNER_YET) {
      return this.$tx(
        "form.smartAb.verdict.noWinnerDesc",
        "两个版本均已达到{n}名独立曝光访客，但版本最高胜出率 {p}%（低于90%），系统将继续收集数据。",
      )
        .replace("{n}", n)
        .replace("{p}", this.winProbPct || "-");
    }
    if (this.verdict === VERDICT.DATA_ANOMALY) {
      return this.$tx(
        "form.smartAb.verdict.anomalyDesc",
        "检测到流量或埋点异常，已暂停系统推荐；你仍可手动选胜或结束实验。",
      );
    }
    return this.$tx(
      "form.smartAb.verdict.collectingDesc",
      "任一版本独立曝光访客数未达到{n}人，系统将继续收集数据，达到门槛前不产生选优建议。",
    ).replace("{n}", n);
  }

  get hintText() {
    return this.$tx(
      "form.smartAb.winProbHint",
      "胜出概率表示：基于当前曝光和提交数据，该版本真实提交转化率高于另一版本的可能性。",
    );
  }
}
